import {createSlice, Draft, PayloadAction} from '@reduxjs/toolkit';
import {useSelector} from "react-redux";

// Define a type for the slice state
interface ImportData {
    importState:boolean,
    uploadType: string,
    uploadStep: string,
    uploadCount: number,
    uploadTotal: number
}

// Define the initial state using that type
const initialState: ImportData = {
    importState:false,
    uploadType: '',
    uploadStep: '',
    uploadCount: 0,
    uploadTotal: 0,
};

let beforeunload = (e: any) => {
    e.preventDefault();
}

export const importSlice = createSlice({
    name: 'import',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        startUpload: (state) => {
            window.addEventListener('beforeunload', beforeunload);
        },
        setUploadStatus: (state, action: PayloadAction<any>) => {
            state.uploadType = action.payload.type;
            state.uploadStep = action.payload.step;
            state.uploadCount = action.payload.count;
            state.uploadTotal = action.payload.total;
        },
        setImportState:(state, action:PayloadAction<any>)=>{
            state.importState=action.payload;
        },
        resetUploadStatus: (state, action:PayloadAction<any>) => {
            state.importState=action.payload;
            state.uploadType = '';
            state.uploadStep = '';
            state.uploadCount = 0;
            state.uploadTotal = 0;

            window.removeEventListener('beforeunload', beforeunload);
        }
    },
});

export const {
    setImportState,
    startUpload,
    setUploadStatus,
    resetUploadStatus
} = importSlice.actions;

export default importSlice.reducer;
